import { iWACallLog } from "@sdk/wa-call-logs/wa-call-logs-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { WACallLogsDefaultQueryConfig } from "./wa-call-logs-default-query";

export const {
  slice: WACallLogsSlice,
  reducers: WACallLogsSliceReducer,
  actions: {
    setEntityQueryResults: setWACallLogsQueryResults,
    setEntity: setWACallLog,
    setEntities: setWACallLogs,
    patchEntity: patchWACallLog,
    addNewEntity: addNewWACallLog,
    setEntityFetchingStatus: setWACallLogFetchingStatus,
    setEntitiesFetchingStatus: setWACallLogsFetchingStatus,
    setEntityFailedStatus: setWACallLogFailedStatus,
    setEntityQueryError: setWACallLogsQueryError,
    resetQuery: resetWACallLogsQuery,
    setQueryList: setWACallLogQueryList,
  },
} = CreateEntitySlice<iWACallLog>({
  sliceName: "WACallLogs",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...WACallLogsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
